import { SCORE_ICE_CARD } from '../../../Constants/Score';
import { IGameState } from '../../Game/IGameState';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import BaseModifierBehavior from './BaseModifierBehavior';

export default class IceModifierBehavior extends BaseModifierBehavior {
    public play(state: IGameState) {
        const currentCard = CardStateHelper.getCurrentCard(state);
        state = CardStateHelper.setCardDiscarded(state, currentCard);

        // Set action data to trigger ice-break animation.
        state = CardStateHelper.addTurnScore(state, SCORE_ICE_CARD);
        state = CardStateHelper.setStateTaskData(state, {
            task: CardTask.ICE,
            discard: currentCard,
            source: this.cardID,
            cards: [currentCard, this.cardID],
            cardScore: SCORE_ICE_CARD,
        });

        // Clear the undo history when a ice card is played.
        state = CardStateHelper.clearUndoHistory(state);

        return state;
    }

    public overrideCardPlay(state: IGameState): boolean {
        return this.modifier.properties.plays === 0;
    }
}
